module.exports = __webpack_public_path__ + "img/banker-green_600.cdce8d9b.png";